import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

export const RecommendationCell = ({ recommendation, hasIncreasedHeight }) => {
  const RECOMMENDATIONS = {
    0: t`weak`,
    1: t`strong`,
    2: t`very strong`,
  }
  const text =
    typeof recommendation === 'number'
      ? RECOMMENDATIONS[String(recommendation)]
      : '-'

  return (
    <Table.Cell type="body" {...{ hasIncreasedHeight }}>
      <Box align="center" justify="center" tagName="span">
        {text}
      </Box>
    </Table.Cell>
  )
}
